import { Box, Button, Card, CardContent, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import CryptoJS from "crypto-js";
import { useState } from "react";
import { getUserData } from "../../Actions/common";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { CRYPTO_TOKEN_SECRET_KEY } from "../../config";
import TransactionReportModel from "./TransactionReport";
import { MyAssessmentIcon } from "../../Assets/svg/MyIcons";
import RevenueReport from "./RevenueReport";
import InvoiceReport from "./InvoiceReports";
import TenantRegistrationReport from "./TenantRegistrationReport";
import { Grid } from "@mui/system";
import TrialReports from "./TrialReports";
import TransactionReport from "./TransactionReport";
import FailedTransactionReport from "./FailedTransactionReport";
import ProductPerformanceReport from "./ProductPerformanceReport";

const getPermissionData = (key) => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem(key), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const reports = [
  {
    key: "tenant",
    label: "Tenant Registration",
    component: <TenantRegistrationReport />,
  },
  {
    key: "revenue",
    label: "Revenue Report",
    component: <RevenueReport />,
  },
  {
    key: "invoice",
    label: "Invoice Report",
    component: <InvoiceReport />,
  },
  {
    key: "trial",
    label: "Trial Report",
    component: <TrialReports />,
  },
  {
    key: "transaction",
    label: "Transaction Report",
    component: <TransactionReport />,
  },
  {
    key:"failedTransaction",
    label: "Failed Transaction Report",
    component: <FailedTransactionReport />
  },
  {
    key: "productPerformance",
    label: "Product Performance Report",
    component: <ProductPerformanceReport />
  },
];

const ReportsSection = () => {
  // const userData = localStorage.getItem("userData") ? getUserData() : null;
  // const permission = localStorage.getItem(`${userData?.id}_permissionData`) ? getPermissionData(`${userData?.id}_permissionData`) : [];

  // const transactionReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "transaction");
  // const payoutReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "withdrawal");
  // const paymentHistoryReportModule = permission[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "payment-history");

  const [activeReport, setActiveReport] = useState(
    reports[0]?.key
  );

  // const [openModal, setOpenModal] = useState(
  //   transactionReportModule?.canView ? "Transaction Report" : payoutReportModule?.canView ? "Payout Report" : paymentHistoryReportModule?.canView ? "Payment History Report" : ""
  // );

  // const handleOpenModal = (reportName) => {
  //   setOpenModal(reportName);
  // };

  return (
    <>
      <BreadcrumbsComponent />
      <Box
        sx={{
          mb: 4,
          background: "#ffffff",
          borderRadius: "12px",
          p: "6px",
          boxShadow:
            "0px 4px 16px rgba(0,0,0,0.08)",
          display: "flex",
          gap: 1,
          overflowX: "auto",
          width: "100%",
        }}
      >
        {reports.map((report) => (
          <Box
            key={report.key}
            onClick={() =>
              setActiveReport(report.key)
            }
            sx={{
              cursor: "pointer",
              px: 3,
              py: 1.5,
              borderRadius: "10px",
              fontWeight: 600,
              whiteSpace: "nowrap",
              transition: "all .25s ease",

              background:
                activeReport === report.key
                  ? "#22419e"
                  : "transparent",

              color:
                activeReport === report.key
                  ? "#fff"
                  : "#475569",

              "&:hover": {
                background:
                  activeReport === report.key
                    ? "#22419e"
                    : "#eef2ff",
              },
            }}
          >
            {report.label}
          </Box>
        ))}
      </Box>

      {/* <TenantRegistrationReport />
      <RevenueReport />
      <InvoiceReport /> */}
      {activeReport === "tenant" && (
        <TenantRegistrationReport />
      )}

      {activeReport === "revenue" && (
        <RevenueReport />
      )}

      {activeReport === "invoice" && (
        <InvoiceReport />
      )}

      {activeReport === "trial" && (
        <TrialReports />
      )}

      {activeReport === "transaction" && (
        <TransactionReport />
      )}

      {activeReport === "failedTransaction" && (
        <FailedTransactionReport />
      )}

      {activeReport === "productPerformance" && (
        <ProductPerformanceReport />
      )}
    </>
  );
};

export default ReportsSection;
